export default "__VITE_ASSET__BFETm4XB__"